export default __webpack_public_path__ + "static/media/switch-app.ec4c62de.svg";